/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchAuditResponse } from './search-audit-response';


export interface SearchAuditResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchAuditResponse> | null;
}

